import { Button } from '@/components/ui/button.tsx'
import { Dialog } from '@/components/ui/dialog.tsx'

interface Props {
  open: boolean
  onClose: () => void
  onDelete: () => void
  selectedCount?: number
}

export const DeleteWordsConfirmationDialog = ({
  open,
  onClose,
  selectedCount,
  onDelete,
}: Props) => {
  const isDeletingSelected = !!selectedCount

  return (
    <Dialog
      containerClassName="bg-[#00000077]"
      show={open}
      onClose={onClose}
    >
      <Dialog.Header>
        <Dialog.Title>
          {isDeletingSelected
            ? 'Delete selected words'
            : 'Delete selected word'}
        </Dialog.Title>
        {isDeletingSelected && (
          <Dialog.Description className="text-center">
            This action will delete all selected words
          </Dialog.Description>
        )}
      </Dialog.Header>

      <div className="mt-5 text-center">
        Are you sure you want to delete the{' '}
        {isDeletingSelected ? `selected ${selectedCount} words` : 'word'}?
      </div>

      <Dialog.Footer className="flex gap-2">
        <Button
          className="flex-1"
          onClick={onClose}
          variant="outline"
        >
          Cancel
        </Button>
        <Button
          onClick={onDelete}
          variant="destructive"
          className="flex-1"
        >
          Delete
        </Button>
      </Dialog.Footer>
    </Dialog>
  )
}
